module.exports = __webpack_public_path__ + "a28df885bac8e22601aee193e7803bfe.pdf";